const r = (t) => t.scrollTop;
function a(t, i) {
  const {
    timeout: n,
    easing: o,
    style: e = {}
  } = t;
  return {
    duration: e.transitionDuration ?? (typeof n == "number" ? n : n[i.mode] || 0),
    easing: e.transitionTimingFunction ?? (typeof o == "object" ? o[i.mode] : o),
    delay: e.transitionDelay
  };
}
export {
  a as getTransitionProps,
  r as reflow
};
